import { gql } from '@apollo/client';


//DELETE mutations

export const DELETE_COUPON = gql`
  mutation DeleteCupon($subjectId: ID!) {
    deleteCupon(id: $subjectId) {
      data {
        id
      }
    }
  }
`;


export const GET_USER_COUPONS = gql`
  query getUserCoupons($userId: ID!, $limit: Int, $offset: Int) {
    cupons(
      filters: {users_permissions_user: { id: { eq: $userId } } },
      pagination: { start: $offset, limit: $limit },
      sort: "daysValid:asc"  # Adding sort parameter
    ) {
      data {
        id
        attributes {
          name
          description
          percentage
          daysValid
          imageLink
          createdAt
          webLink
          users_permissions_user {
            data {
              id
            }
          }
        }
      }
    }
  }
`;
